if (window.scriptLoad == 'register') {
        console.log('register');
        window.mailOk = false;
        window.loginOk = false;

        function loginAndMailOK() {
            return loginOk && checkMail();
        }

        $('#log1').keyup(function () {
            var str = $(this).val();

            $.ajax({
                type: "GET",
                async: false,
                url: "/page/sprawdz.php",
                data: "a=1&login=" + str,
                success: function (msg) {

                    if (msg == "") {
                        window.loginOk = true;
                    } else {
                        window.loginOk = false;
                    }

                    printErrors();

                    if (loginAndMailOK()) {
                        $("#B1").removeAttr("disabled");
                    } else {
                        $("#B1").attr("disabled", "disabled");
                    }
                }
            });
        });

        $('#mails').keyup(function () {
            var str = $(this).val();
            $.ajax({
                type: "GET",
                async: false,
                url: "/page/sprawdz.php",
                data: "a=3&mail=" + str,
                success: function (msg) {


                    if (msg == "") {
                        window.mailOk = true;
                    } else {
                        window.mailOk = false;
                    }

                    printErrors();

                    if (loginAndMailOK()) {
                        $("#B1").removeAttr("disabled");
                    } else {
                        $("#B1").attr("disabled", "disabled");
                    }
                }
            });
        });

        function printErrors() {
            $("#info").text("");

            if (loginOk == false) {
                $("#info").append(window.lang.TXT_FORM_REJ_E_1);
            }
            if (checkMail() == false) {
                $("#info").append(window.lang.TXT_FORM_REJ_E_2);
            }
        }

        function checkMail() {
            if (($("#mails").attr('value') != null) && (mailOk == false)) {
                return false;
            } else {
                return true;
            }
        }

        $('#form0').submit(function () {

            if ((this.log1.value == '') || (this.log1.value == ' ')) {
                $('#info').text(window.lang.TXT_FORM_REJ_E_3);
                return false;
            }

            if (this.pas1.value == '') {
                $('#info').text(window.lang.TXT_FORM_REJ_E_4);
                return false;
            }

            if (this.pas2.value == '') {
                $('#info').text(window.lang.TXT_FORM_REJ_E_4);
                return false;
            }

            if (this.pas2.value != this.pas1.value) {
                $('#info').text(window.lang.TXT_FORM_REJ_E_5);
                return false;
            }

            if ($('#id2')[0].checked) {
                if ((this.firma.value == '') || (this.firma.value == ' ')) {
                    $('#info').text(window.lang.TXT_FORM_REJ_E_6);
                    return false;
                }

                if ((this.nip.value == '') || (this.nip.value == ' ')) {
                    $('#info').text("<?echo $lang['TXT_FORM_REJ_E_7']?>");
                    return false;
                }
            }

            if ((this.imie.value == '') || (this.imie.value == ' ')) {
                $('#info').text(window.lang.TXT_FORM_REJ_E_8);
                return false;
            }

            if ((this.nazwisko.value == '') || (this.nazwisko.value == ' ')) {
                $('#info').text(window.lang.TXT_FORM_REJ_E_9);
                return false;
            }

            if ((this.mails.value == '') || (this.mails.value == ' ')) {
                $('#info').text(window.lang.TXT_FORM_REJ_E_10);
                return false;
            }


            maska = /^([a-zA-Z0-9_.+-]+)@([a-zA-Z0-9.-]+)\.([a-zA-Z0-9]+)$/;
            if (maska.test(this.mails.value) == false) {
                $('#info').text(window.lang.TXT_FORM_REJ_E_10);
                return false;
            }

            if (this.mails.value != this.mails2.value) {
                $('#info').text("E-Mail-Adressen stimmen nicht überein");
                return false;
            }

            if ((this.kod.value == '') || (this.kod.value == ' ')) {
                $('#info').text(window.lang.TXT_FORM_REJ_E_11);
                return false;
            }

            if ((this.miasto.value == '') || (this.miasto.value == ' ')) {
                $('#info').text(window.lang.TXT_FORM_REJ_E_12);
                return false;
            }

            if ((this.ulica.value == '') || (this.ulica.value == ' ')) {
                $('#info').text(window.lang.TXT_FORM_REJ_E_13);
                return false;
            }

            if ((this.nrbud.value == '') || (this.nrbud.value == ' ')) {
                $('#info').text(window.lang.TXT_FORM_REJ_E_14);
                return false;
            }

            if ((this.tel.value == '') || (this.tel.value == ' ')) {
                $('#info').text("Bitte geben Sie Ihre Telefonnummer");
                return false;
            }


            /*
            if (!this.agree1.checked) {
                    $('#info').text(window.lang.TXT_FORM_REJ_E_15);
                    return false;
            }
            */

        });

        $('#id1').click(function () {
            $("#dev2").fadeIn().hide();
            $("#dev1").fadeIn().show();

        });

        $('#id2').click(function () {
            $("#dev1").fadeIn().hide();
            $("#dev2").fadeIn().show();

        });

        $("#dev1").fadeIn().show();
}
